export { default } from "./PasswordReveal";
